import React, { useState, useEffect } from "react";
// eslint-disable-next-line
import {
  Link,
  Route,
  Routes,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import * as flatted from "flatted";

// const socket = io.connect('http://localhost:3000');
import axios from "axios";

import Students from "./Mapofstudents/Mapofstudents";

// eslint-disable-next-line
import { auth, firebase } from "../Firebase/config";
// eslint-disable-next-line
import {
  onSnapshot,
  orderBy,
  limit,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  FieldValue,
  getCountFromServer,
} from "@firebase/firestore";

import {
  admin,
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  onAuthStateChanged,
  deleteUser,
} from "@firebase/auth";
// eslint-disable-next-line
import NavBar from "./Navbar";

import "./Messages.css";

const MAX = 10;

function Getclasses({ route, navigation }) {
  // eslint-disable-line no-unused-vars

  const { only2studentid, studentid, classid, language, role } = useParams();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [donotshow, setDonotshow] = useState();
  const [someoneisloggedin, setSomeoneisloggedin] = useState(false);
  const [id2, setId2] = useState();
  const [school2, setSchool2] = useState();
  const [town2, setTown2] = useState();
  const [state2, setState2] = useState();
  const [schoolid2, setSchoolid2] = useState();

  const [role2, setRole2] = useState();
  const [school, setSchool] = useState();
  const [todayspasses, setTodayspasses] = useState();

  const [lasttwomonths, setLasttwomonths] = useState([]);
  const [lasttwomonths2, setLasttwomonths2] = useState();

  const [selectedclass, setSelectedclass] = useState();

  const [updatesent, setUpdatesent] = useState();

  const [activename, setActivename] = useState("Active Passes");

  const [lastupdate, setLastupdate] = useState(0);
  const [selectedpass, setSelectedpass] = useState();
  const [idselected, setIdselected] = useState();
  const [currentstudentid, setCurrentsstudentid] = useState();
  const [arrayofstudentpasses, setArrayofstudentpassees] = useState();

  const [firstname, setFirstname] = useState();
  const [lastname, setLastname] = useState();
  const [studentname, setStudentname] = useState("");
  const [numberofdaysago, setNumberofdaysago] = useState();

  const [newdatestring, setNewdatestring] = useState();
  const [path, setPath] = useState();

  const [currentUrl, setCurrentUrl] = useState(window.location.href);

  const [popupData, setPopupData] = useState(null);

  const auth = getAuth();

  const location = useLocation();

  const [newWindow, setNewWindow] = useState(null);

  const [urlValue, setUrlValue] = useState("");
  const [data, setData] = useState(null);

  const [stringToSend, setStringToSend] = useState("");

  const [response, setResponse] = useState("");

  const [value, setValue] = useState(720);

  const changeValue2 = async (e) => {
    if (value == 1080) {
      setValue(720);
    } else if (value == 720) {
      setValue(576);
    } else if (value == 576) {
      setValue(480);
    } else if (value == 480) {
      setValue(2160);
    } else if (value == 2160) {
      setValue(1080);
    } else {
      setValue(720);
    }
  };


  const getmp44 = async (f) => {
    if (value == 1080) {
        handleSubmit21080(f);
    } else if (value == 720) {
        handleSubmit2720(f);
    } else if (value == 576) {
        handleSubmit2576(f);
    } else if (value == 480) {
        handleSubmit2480(f); 
    } else if (value == 2160) {
        handleSubmit22160(f)
    } else {
        handleSubmit2720(f);
    }
  };

  const handleSubmit21 = async (e) => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      handleSubmit21a(e);
    } else {
      handleSubmit21b(e);
    }
  };

  const handleSubmit21a = async (event) => {
    event.preventDefault();
  
    const data = {
      name: 'John Doe',
      email: 'john.doe@example.com'
    };
  
    try {
      const response = await axios.post('http://localhost:3002/api/users', data);
      console.log(response.data); // Handle the response from the server
    } catch (error) {
      console.error(error); // Handle any errors
    }
  };

  const handleSubmit21b = async (event) => {
    event.preventDefault();
  
    const data = {
      name: 'John Doe',
      email: 'john.doe@example.com'
    };
  
    // try {
    //   const response = await axios.post('https://sleepy-falls-78216-6abb1d3b0d95.herokuapp.com/api/users', data);
    //   console.log(response.data); // Handle the response from the server
    // } catch (error) {
    //   console.error(error); // Handle any errors
    // }
  };
 
  const handleSubmit22160 = async (e) => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      handleSubmit32160(e);
    } else {
      handleSubmit42160(e);
    }
  };

  const handleSubmit32160 = async (e) => {
    if (stringToSend !== "") {
      alert(stringToSend + "AAA");
      try {
        const res = await axios.post("http://localhost:3002/mp4/2160", {
          data: stringToSend,
        });
        alert(res.data);
      } catch (error) {
        alert("Process Failed");
      }
    }
  };

  const handleSubmit42160= async (e) => {
    // if (stringToSend !== "") {
    //   alert(stringToSend + "BBB");
    //   try {
    //     const res = await axios.post(
    //       "https://sleepy-falls-78216-6abb1d3b0d95.herokuapp.com/mp4/2160",
    //       {
    //         data: stringToSend,
    //       }
    //     );
    //     alert(res.data);
    // } catch (error) {
    //   alert("Process Failed");
    //   }
    // }
  };


  const handleSubmit2480 = async (e) => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      handleSubmit3480(e);
    } else {
      handleSubmit4480(e);
    }
  };

  const handleSubmit3480 = async (e) => {
    if (stringToSend !== "") {
      alert(stringToSend + "CCC");
      try {
        const res = await axios.post("http://localhost:3002/mp4/480", {
          data: stringToSend,
        });
        alert(res.data);
      } catch (error) {
        alert("Process Failed");
      }
    }
  };

  const handleSubmit4480 = async (e) => {
    // if (stringToSend !== "") {
    //   alert(stringToSend + "DDD");
    //   try {
    //     const res = await axios.post(
    //       "https://sleepy-falls-78216-6abb1d3b0d95.herokuapp.com/mp4/480",
    //       {
    //         data: stringToSend,
    //       }
    //     );
    //     alert(res.data);
    // } catch (error) {
    //   alert("Process Failed");
    //   }
    // }
  };

  const handleSubmit2576 = async (e) => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      handleSubmit3576(e);
    } else {
      handleSubmit4576(e);
    }
  };

  const handleSubmit3576 = async (e) => {
    if (stringToSend !== "") {
      alert(stringToSend + "EEE");
      try {
        const res = await axios.post("http://localhost:3002/mp4/576", {
          data: stringToSend,
        });
        alert(res.data);
      } catch (error) {
        alert("Process Failed");
      }
    }
  };

  const handleSubmit4576 = async (e) => {
    // if (stringToSend !== "") {
    //   alert(stringToSend + "FFF");
    //   try {
    //     const res = await axios.post(
    //       "https://sleepy-falls-78216-6abb1d3b0d95.herokuapp.com/mp4/576",
    //       {
    //         data: stringToSend,
    //       }
    //     );
    //     alert(res.data);
    // } catch (error) {
    //   alert("Process Failed");
    //   }
    // }
  };

  const handleSubmit2720 = async (e) => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      handleSubmit3720(e);
    } else {
      handleSubmit4720(e);
    }
  };

  const handleSubmit3720 = async (event) => {
    event.preventDefault();
    if (stringToSend !== "") {
      alert(stringToSend + "GGG");
      try {
        const res = await axios.post("http://localhost:3002/mp4/720", {
          data: stringToSend,
        });
        alert(res.data);
      } catch (error) {
        alert("Process Failed" + error + "GGG")
      }
    }
  };

  const handleSubmit4720 = async (event) => {
    event.preventDefault();


    // if (stringToSend !== "") {
    //   alert(stringToSend + "HHH");
    //   try {
    //     const res = await axios.post(
    //       "https://sleepy-falls-78216-6abb1d3b0d95.herokuapp.com/mp4/720",
    //       {
    //         data: stringToSend,
    //       }
    //     );
       
    // } catch (error) {
    //   alert(error);
    //   }
    // }
  };

  const handleSubmit21080 = async (e) => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      handleSubmit31080(e);
    } else {
      handleSubmit41080(e);
    }
  };

  const handleSubmit31080 = async (e) => {
    if (stringToSend !== "") {
      alert(stringToSend + "JJJ");

      try {
        const res = await axios.post("http://localhost:3002/mp4/1080", {
          data: stringToSend,
        });
        alert(res.data);
    } catch (error) {
      alert("Process Failed");
      }
    }
  };

  const handleSubmit41080 = async (e) => {
    // if (stringToSend !== "") {

    //   alert(stringToSend + "KKK");
    //   try {
    //     const res = await axios.post(
    //       "https://sleepy-falls-78216-6abb1d3b0d95.herokuapp.com/mp4/1080",
    //       {
    //         data: stringToSend,
    //       }
    //     );
    //     alert(res.data);
    // } catch (error) {
    //   alert("Process Failed");
    //   }
    // }
  };


  const handleSubmittest = async (e) => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      handleSubmittest2(e) 
  } else {
    handleSubmittest3(e) 
  }
    }

  const handleSubmittest3 = async () => {
    
  // try {
  //   const response = await axios.get("https://sleepy-falls-78216-6abb1d3b0d95.herokuapp.com/api/hello");
  //   alert(response.data.message);
  // } catch (error) {
  //   console.error("Error fetching health status:", error);
  // }
  };

  const handleSubmittest2 = async () => {
    try {
      const response = await axios.get("http://localhost:3002/api/hello");
      alert(response.data.message);
    } catch (error) {
      console.error("Error fetching health status:", error);
    }
    };
  const navigate = useNavigate();



  return (
    <div className="App22">
      <NavBar
        donotshow={donotshow}
        role={role}
        setSelectedclass={setSelectedclass}
        activename={activename}
      />
      <div className="App29">
        {/* //frontend Youtube Downolader */}

        {/* end */}

        <header className="App-header">
          <div className="container2">
            <div className="section591abc">
              <h1>Enter Link Below</h1>
              <br></br>
              <div>
                <form onSubmit={getmp44}>
                  <input
                    type="text"
                    value={stringToSend}
                    style={{
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                    onChange={(e) => setStringToSend(e.target.value)}
                  />
                  <br></br>
                  <br></br>

                 {stringToSend.length > 0 ? <div><span className="mp4style" onClick={getmp44}>Get mp4 ({value}p)</span><button type="submit">Get MP4</button><span style={{ color: "black" }}>ds</span><span className="mp4style1"
                    onClick={() => changeValue2()}
                  >
                    ➡︎
                  </span></div> : null}

                </form>
                <button onClick={handleSubmittest}>Check if connected</button>
                <button onClick={handleSubmit21}>Post Call</button>
              </div>
            </div>
          </div>
        </header>
      </div>
    </div>
  );
}

export default Getclasses;